<template>
	<label class="check">
		<input
			class="check-input"
			type="checkbox"
			@click="onCheck"
			:checked="isCheck"
			:disabled="disabled"
		/>
		<span class="checkmark checkmark-hd"></span>
		<span class="option-title">{{ optionText }}</span>
	</label>
</template>

<script>
export default {
	name: 'CheckboxComponent',
	props: {
		isCheck: {
			type: Boolean,
			default: false,
		},
		disabled: {
			type: Boolean,
			default: false,
		},
		optionText: String,
		onCheck: Function,
	},
}
</script>

<style lang="scss" scoped>
.check {
	cursor: pointer;
	display: block;
	font-size: 16px;
	line-height: 20px;
	margin-bottom: 0;
	padding-left: 25px;
	position: relative;

	.check-input {
		position: absolute;
		opacity: 0;
		cursor: pointer;
	}

	.check-input:checked ~ .checkmark {
		background-color: #fff;
	}

	.check-input:checked ~ .checkmark:after {
		display: block;
	}

	.checkmark {
		position: absolute;
		top: 3px;
		left: 0;
		height: 18px;
		width: 18px;
		background-color: #fff;
		border-color: #01a351;
		border-style: solid;
		border-width: 2px;

		&:after {
			content: '';
			border: solid;
			border-color: #01a351;
			border-width: 0 3px 3px 0;
			display: none;
			position: absolute;
			left: 5px;
			top: 1px;
			width: 5px;
			height: 10px;
			-webkit-transform: rotate(45deg);
			-ms-transform: rotate(45deg);
			transform: rotate(45deg);
		}
	}

	.option-title {
		margin-left: 4px;
	}
}
</style>
